import { Component, EventEmitter, Output } from '@angular/core';
import { animations } from './support-modal.animations';
import { TranslationService } from 'src/app/services/translation.service';
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { Router } from '@angular/router';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';

@Component({
  selector: 'app-support-modal',
  templateUrl: './support-modal.component.html',
  styleUrls: ['./support-modal.component.scss'],
  animations: animations,
  standalone: false,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'general',
    },
  ],
})
export class SupportModalComponent {
  @Output() closeModalEvent = new EventEmitter<void>();
  isClosing: boolean = false;
  
  readonly knowledgeBaseUrl = 'https://quantified.helpscoutdocs.com/';
  readonly helpEmailUrl = 'mailto:help@quantified.ai';

  constructor(
    private translationService: TranslationService,
    private amplitudeService: AmplitudeService,
    private router: Router
  ) {}

  ngOnInit() {
    this.translationService.loadScopedTranslation('general');
  }

  closeModal() {
    this.isClosing = true;
  }

  onAnimationDone() {
    if (this.isClosing) {
      this.closeModalEvent.emit();
      this.isClosing = false;
    }
  }

  onKnowledgeBaseClick(): void {
    const pageName = this.router.url && this.router.url.trim() ? this.router.url : 'unknown';
    console.log('pageName', pageName);
    this.amplitudeService.trackEvent(AmplitudeTrackingEvents.HELPMODAL_CLICK_KNOWLEDGEBASE, {
      page_name: pageName,
    });
  }
}
